export enum Category {
    GENERAL = "general",
    ISDA = "isda"
}